import { render, staticRenderFns } from "./edit_pdpa.vue?vue&type=template&id=75993889&scoped=true"
import script from "./edit_pdpa.vue?vue&type=script&lang=js"
export * from "./edit_pdpa.vue?vue&type=script&lang=js"
import style0 from "./edit_pdpa.vue?vue&type=style&index=0&id=75993889&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75993889",
  null
  
)

export default component.exports